import React, { useState } from 'react';
import TopSection from "./TopSection";
import { Helmet } from "react-helmet-async";

const awardsData = [
    {
      year: 2024,
      awards: [
        { category: "Лидер года в строительной отрасли", name: "Артём Блинов (Россия)", description: "за успешное управление строительством крупнейшего делового квартала в Москве, установление новых стандартов девелопмента." },
        { category: "За внедрение инноваций в строительстве", name: "Александр Пушкарь (Молдова)", description: "за внедрение технологий модульного строительства, сокращающих сроки возведения зданий вдвое." },
        { category: "Лучший руководитель строительной компании", name: "Данияр Сагдиев (Казахстан)", description: "за достижение рекордных финансовых показателей и расширение строительных мощностей компании." },
        { category: "Эффективное управление проектами", name: "Игорь Станкевич (Беларусь)", description: "за успешное завершение масштабного инфраструктурного проекта в Минске в рекордные сроки." },
        { category: "За вклад в устойчивое строительство", name: "Жанна Рахимова (Узбекистан)", description: "за разработку экологичных проектов с минимальным воздействием на окружающую среду." },
        { category: "Лидер цифровой трансформации в строительстве", name: "Олег Грушин (Россия)", description: "за интеграцию цифрового контроля качества строительства на всех этапах работы компании." },
        { category: "За вклад в развитие отрасли", name: "Самир Алиев (Азербайджан)", description: "за создание образовательных программ для подготовки высококвалифицированных специалистов в строительной индустрии." },
        { category: "Командный лидер года", name: "Татьяна Колесникова (Беларусь)", description: "за формирование команды профессионалов, которая вывела компанию в лидеры по числу успешных проектов." },
        { category: "За стратегическое управление развитием компании", name: "Рустам Каримов (Казахстан)", description: "за успешную диверсификацию бизнеса и открытие новых направлений в девелопменте." },
        { category: "За развитие корпоративной культуры и команды", name: "Лилия Марченко (Россия)", description: "за создание программы мотивации сотрудников, увеличившей производительность на 30%." }
      ]
    },
    {
      year: 2023,
      awards: [
        { category: "Лидер года в строительной отрасли", name: "Иван Петров (Россия)", description: "за руководство крупнейшим инфраструктурным проектом в стране, включая строительство скоростных автомагистралей." },
        { category: "За внедрение инноваций в строительстве", name: "Александр Ковальчук (Россия)", description: "за разработку и внедрение системы 3D-печати жилых домов, сокращающую сроки строительства на 40%." },
        { category: "Лучший руководитель строительной компании", name: "Сергей Иваненко (Беларусь)", description: "за достижение рекордных показателей по объему строительства жилых комплексов в стране." },
        { category: "Эффективное управление проектами", name: "Бахтияр Исмаилов (Казахстан)", description: "за успешную реализацию сложного городского инфраструктурного проекта в Алматы." },
        { category: "За вклад в устойчивое строительство", name: "Наталья Гринёва (Россия)", description: "за внедрение экологически чистых строительных материалов в массовое производство." },
        { category: "Лидер цифровой трансформации в строительстве", name: "Дмитрий Сидоренко (Молдова)", description: "за внедрение цифрового моделирования BIM на всех этапах строительства." },
        { category: "За вклад в развитие отрасли", name: "Михаил Ахмедов (Азербайджан)", description: "за популяризацию профессии строителя и запуск образовательных программ." },
        { category: "Командный лидер года", name: "Валентина Климова (Беларусь)", description: "за создание сплоченной команды, достигшей значительных успехов в строительстве коммерческой недвижимости." },
        { category: "За стратегическое управление развитием компании", name: "Руслан Каримов (Узбекистан)", description: "за успешный выход строительной компании на международный рынок." },
        { category: "За развитие корпоративной культуры и команды", name: "Екатерина Миронова (Казахстан)", description: "за создание благоприятной рабочей среды и повышение мотивации сотрудников." }
      ]
    },
    {
      year: 2022,
      awards: [
        { category: "Лидер года в строительной отрасли", name: "Андрей Богданов (Россия)", description: "за руководство строительством крупнейшего жилого комплекса в Москве." },
        { category: "За внедрение инноваций в строительстве", name: "Артем Сташков (Беларусь)", description: "за автоматизацию строительных процессов с помощью ИИ." },
        { category: "Лучший руководитель строительной компании", name: "Олег Громов (Казахстан)", description: "за успешное развитие компании и увеличение объемов строительства на 25%." },
        { category: "Эффективное управление проектами", name: "Айдар Рахимов (Узбекистан)", description: "за безупречное соблюдение сроков реализации государственных строительных проектов." },
        { category: "За вклад в устойчивое строительство", name: "Людмила Боровская (Россия)", description: "за активное внедрение технологий энергосбережения." },
        { category: "Лидер цифровой трансформации в строительстве", name: "Даниил Терещенко (Россия)", description: "за цифровизацию строительных процессов и применение IoT." },
        { category: "За вклад в развитие отрасли", name: "Тимур Алиев (Азербайджан)", description: "за организацию международных строительных форумов и популяризацию строительных профессий." },
        { category: "Командный лидер года", name: "Марина Кравцова (Беларусь)", description: "за создание команды профессионалов, обеспечивших успешную реализацию масштабных проектов." },
        { category: "За стратегическое управление развитием компании", name: "Сергей Агапов (Казахстан)", description: "за успешную экспансию компании на зарубежные рынки." },
        { category: "За развитие корпоративной культуры и команды", name: "Анна Федоренко (Молдова)", description: "за создание корпоративных стандартов и программ по развитию сотрудников." }
      ]
    },
    {
      year: 2021,
      awards: [
        { category: "Лидер года в строительной отрасли", name: "Петр Назаров (Россия)", description: "за модернизацию крупнейшего строительного холдинга и успешное управление масштабными инфраструктурными проектами." },
        { category: "За внедрение инноваций в строительстве", name: "Виктор Чубаров (Беларусь)", description: "за разработку и внедрение инновационных строительных материалов с повышенной энергоэффективностью." },
        { category: "Лучший руководитель строительной компании", name: "Рано Хамракул (Казахстан)", description: "за внедрение инновационных решений в реконструкции жилых объектов и успешное управление проектами в сфере ремонта и дизайна." },
        { category: "Эффективное управление проектами", name: "Марат Сафаров (Узбекистан)", description: "за успешную координацию строительства крупнейшего многофункционального комплекса в Ташкенте, завершенного в рекордные сроки." },
        { category: "За вклад в устойчивое строительство", name: "Оксана Левченко (Украина)", description: "за разработку и внедрение технологий 'зеленого' строительства, минимизирующих углеродный след." },
        { category: "Лидер цифровой трансформации в строительстве", name: "Дмитрий Ткаченко (Россия)", description: "за цифровизацию строительных процессов и внедрение технологии BIM-моделирования." },
        { category: "За вклад в развитие отрасли", name: "Тимур Алиев (Азербайджан)", description: "за организацию международных строительных форумов и популяризацию строительных профессий." },
        { category: "Командный лидер года", name: "Марина Кравцова (Беларусь)", description: "за создание высокоэффективной команды, реализовавшей несколько крупных проектов с опережением сроков." },
        { category: "За стратегическое управление развитием компании", name: "Сергей Агапов (Казахстан)", description: "за успешную экспансию компании на зарубежные рынки и увеличение объемов строительства." },
        { category: "За развитие корпоративной культуры и команды", name: "Анна Федоренко (Украина)", description: "за создание корпоративных стандартов и программ по развитию сотрудников, повысивших производительность труда." }
      ]
    },
    {
      year: 2020,
      awards: [
        { category: "Лидер года в строительной отрасли", name: "Владимир Коваленко (Украина)", description: "за успешное развитие инфраструктурных проектов, включая реконструкцию автомагистралей." },
        { category: "За внедрение инноваций в строительстве", name: "Егор Платонов (Россия)", description: "за внедрение автоматизированных технологий в строительстве и использование искусственного интеллекта для управления проектами." },
        { category: "Лучший руководитель строительной компании", name: "Игорь Романов (Беларусь)", description: "за достижение стабильного роста компании в условиях кризиса и сохранение рабочих мест." },
        { category: "Эффективное управление проектами", name: "Айбек Исмаилов (Казахстан)", description: "за успешное управление строительством жилых комплексов, несмотря на сложные экономические условия." },
        { category: "За вклад в устойчивое строительство", name: "Тимур Алиев (Азербайджан)", description: "за реализацию масштабных энергоэффективных проектов и развитие технологий переработки строительных отходов." },
        { category: "Лидер цифровой трансформации в строительстве", name: "Руслан Горин (Россия)", description: "за внедрение автоматизированных решений в управлении строительными процессами и применение дронов для мониторинга объектов." },
        { category: "За вклад в развитие отрасли", name: "Бахтияр Омаров (Узбекистан)", description: "за реформирование строительного законодательства и внедрение новых стандартов безопасности." },
        { category: "Командный лидер года", name: "Владислав Нестеров (Беларусь)", description: "за создание сильной команды инженеров и строителей, работающих на крупнейших объектах страны." },
        { category: "За стратегическое управление развитием компании", name: "Михаил Головин (Казахстан)", description: "за разработку стратегии диверсификации бизнеса и освоение новых рынков." },
        { category: "За развитие корпоративной культуры и команды", name: "Екатерина Руденко (Украина)", description: "за внедрение корпоративных ценностей, повысивших вовлеченность сотрудников и их профессиональный рост." }
      ]
    }
  ];
  

const Awards = () => {
  const [activeYear, setActiveYear] = useState(2024);

  const handlePrevYear = () => {
    setActiveYear((prevYear) => {
      const prevYearData = awardsData.find((data) => data.year === prevYear - 1);
      return prevYearData ? prevYearData.year : prevYear;
    });
  };

  const handleNextYear = () => {
    setActiveYear((prevYear) => {
      const nextYear = awardsData.find((data) => data.year === prevYear + 1);
      return nextYear ? nextYear.year : prevYear;
    });
  };

  const currentAwards = awardsData.find((data) => data.year === activeYear).awards;


  return (
    <>
<Helmet>
  <html lang="ru" />

  <title>
    Рано Хамракул (Rano Khamrakul) — Лучший руководитель строительной компании | Global Construction Cup 2021
  </title>

  <meta
    name="description"
    content="Рано Хамракул (Rano Khamrakul) — победитель Global Construction Cup 2021 в номинации «Лучший руководитель строительной компании» за внедрение инновационных решений в реконструкции жилых объектов и успешное управление проектами в сфере ремонта и дизайна."
  />

  <meta
    name="keywords"
    content="Рано Хамракул, Rano Khamrakul, Рано Хамракул Казахстан, Rano Khamrakul Kazakhstan, Global Construction Cup, Лучший руководитель строительной компании, победитель Global Construction Cup 2021"
  />

  <link
    rel="canonical"
    href="https://globalconstructioncup.com/awards"
  />

  <meta
    property="og:title"
    content="Рано Хамракул (Rano Khamrakul) — Global Construction Cup 2021"
  />

  <meta
    property="og:description"
    content="Победитель Global Construction Cup 2021 в категории «Лучший руководитель строительной компании»."
  />

  <meta
    property="og:url"
    content="https://globalconstructioncup.com/awards"
  />

  <meta property="og:type" content="website" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Rano Khamrakul",
      alternateName: "Рано Хамракул",
      nationality: "Kazakhstan",
      award:
        "Global Construction Cup 2021 — Лучший руководитель строительной компании",
      description:
        "Рано Хамракул (Rano Khamrakul) — победитель Global Construction Cup 2021 за внедрение инновационных решений в реконструкции жилых объектов и успешное управление проектами в сфере ремонта и дизайна.",
      url: "https://globalconstructioncup.com/awards"
    })}
  </script>
</Helmet>
    <TopSection
      subtitle="Победители"
      title="Global Construction Cup"
    />
    <div className="awards">
      <div className="year-navigation">
        <button className="arrow-button prev" onClick={handlePrevYear}>
          &lt;
        </button>
        <h2 className="year-title">Победители {activeYear} года</h2>
        <button className="arrow-button next" onClick={handleNextYear}>
          &gt;
        </button>
      </div>
      <div className="year-awards">
        <ul className="awards-list">
          {currentAwards.map((award, index) => (
            <li key={index} className="awards-item">
              <h3 className="award-category">{award.category}</h3>
              <p className="award-name">{award.name}</p>
              <p className="award-description">{award.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
    </>
  );
};

export default Awards;